'use strict';

var fitt = require('fitt'),
getDispatch = require('./defaults.js').getDispatch,
debug = require('debug')('fitt-http'),
traceWrap,writer;

/**
                   * Internal function that handles returned promise from dispatch and request preparations
                   *
                   * @name fitt-http#sendRequest
                   * @function
                   * @param {String} url - The resource to request
                   * @param {Object} config - The object containing all incoming config parameters
                   * @return {Promise}
                   */

function sendRequest(url, config) {

	// Flatten headers
	config.headers = fitt.mix({}, [config.method_headers[config.method] || {}, config.headers || {}]);

	var dispatch = getDispatch(config.dispatch);

	if (config.transformRequest) {
		fitt.forEach(config.transformRequest, function (fn) {
			config.data = fn(config.data, config.headers);
		});
	}

	if (config.tracing) {
		if (!process.browser) {// Enable http tracing on server-only
			traceWrap = require('./traceWrap');
			dispatch = traceWrap(dispatch, url, config);
		}
	}

	return dispatch(url, config).then(
	function (response) {
		debug('Response received', url, response.status);

		// Validate? Transform?
		if (config.transformResponse) {
			fitt.forEach(config.transformResponse, function (fn) {
				response.data = fn(response.data, response.headers);
			});
		}

		// Write response to disk?
		if (!process.browser) {
			if (config.writeResponse) {
				writer = require('./fileWriter');
				writer(config.writeResponse, response);
			}
		}

		return response;
	},
	function (reason) {
		return Promise.reject(reason);
	});

}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = sendRequest;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/sendRequest.js
// module id = 596
// module chunks = 0